import { Component } from "react";
import RectButton from "../ui/button/RectButton";
import Input from "../ui/Input";
import Select from "../ui/Select";
import Option from "../ui/Select/Option";

import "./style.scss";

class Template extends Component {

    state = {
        editing: this.props.editing,
        name: this.props.name,
        title: this.props.title,
        text: this.props.text,
        mergeField: this.props.mergeField,
        signature: this.props.signature,
        tempName: this.props.name,
        tempTitle: this.props.title,
        tempText: this.props.text,
        tempMergeField: this.props.mergeField,
        tempSignature: this.props.signature,
    }

    onKeyDownTextHandler = (e) => {
        if (this.state.tempText.length >= 500 && e.keyCode !== 8) e.preventDefault();
    }

    onInputTextHandler = (e) => {
        let text = e.target.innerHTML;
        this.setState({ tempText: text })
    }

    onKeyDownTitleHandler = (e) => {
        if (this.state.title.length >= 100 && e.keyCode !== 8) e.preventDefault();
    }

    onInputTitleHandler = (e) => {
        let title = e.target.innerHTML;
        this.setState({ tempTitle: title })
    }

    saveHandler = () => {
        let { tempName, tempTitle, tempText, tempMergeField, tempSignature } = this.state;
        if(!tempName) tempName = "Enter template name";
        let values = {
            id: this.props.id,
            editing: false,
            name: tempName,
            title: tempTitle,
            text: tempText,
            mergeField: tempMergeField,
            signature: tempSignature
        }
        this.setState(values)
        this.props.onSave(values)
    }

    cancelHandler = () => {
        let { name, title, text, mergeField, signature } = this.state;
        this.setState({
            editing: false,
            tempName: name,
            tempTitle: title,
            tempText: text,
            tempMergeField: mergeField,
            tempSignature: signature
        })
        this.textEl.innerHTML = this.state.text;
        if(!name) this.props.onSave(null);
    }

    render() {
        let { editing } = this.state;
        return (
            <>
                <div className={`template box no-padding ${this.state.editing ? "editing" : ""}`}>
                    {
                        editing ?
                            <div className="editor">
                                <div className="row name lock">
                                    <div className="label"><span>Template&nbsp;</span>Name</div>
                                    <Input placeHolder="Enter template name" value={this.state.tempName} onChange={(value) => this.setState({ tempName: value })} />
                                </div>
                                <div className="row selects">
                                    <Select className="add-merge" value={this.state.tempMergeField} onChange={(e) => { this.setState({ tempMergeField: e.target.value }) }}>
                                        <Option hidden={true}>Add Merge Fields</Option>
                                        <Option value="First Name">First Name</Option>
                                        <Option value="Last Name">Last Name</Option>
                                        <Option value="Business Name 1">Business Name 1</Option>
                                        <Option value="Business Name 2">Business Name 2</Option>
                                        <Option value="Business Name 3">Business Name 3</Option>
                                        <Option value="Business Name 4">Business Name 4</Option>
                                        <Option value="Business Name 5">Business Name 5</Option>
                                        <Option value="Business Name 6">Business Name 6</Option>
                                        <Option value="Business Name 7">Business Name 7</Option>
                                        <Option value="Business Name 8">Business Name 8</Option>
                                        <Option value="Business Name 9">Business Name 9</Option>
                                    </Select>
                                    <Select className="isert-signature" value={this.state.tempSignature} onChange={(e) => { this.setState({ tempSignature: e.target.value }) }}>
                                        <Option hidden={true}>Insert Signature</Option>
                                        <Option value="https://via.placeholder.com/213x70/004AAB" label="Signature 1"><img src="https://via.placeholder.com/213x70/004AAB" alt="Signature" /></Option>
                                        <Option value="https://via.placeholder.com/213x70/FFFF00" label="Signature 2"><img src="https://via.placeholder.com/213x70/FFFF00" alt="Signature" /></Option>
                                        <Option value="https://via.placeholder.com/213x70/00FF00" label="Signature 3"><img src="https://via.placeholder.com/213x70/00FF00" alt="Signature" /></Option>
                                        <Option value="https://via.placeholder.com/213x70/00FFFF" label="Signature 4"><img src="https://via.placeholder.com/213x70/00FFFF" alt="Signature" /></Option>
                                        <Option value="https://via.placeholder.com/213x70/FF00FF" label="Signature 5"><img src="https://via.placeholder.com/213x70/FF00FF" alt="Signature" /></Option>
                                    </Select>
                                </div>
                            </div>
                            :
                            <div className="header">Template Name: <span className="name">{this.state.name}</span></div>
                    }
                    <div className="container">
                        <div className="message">
                            {/* <span ref={el => (this.titleEl = el)} className="title" contentEditable={this.state.editing} suppressContentEditableWarning={true} onInput={this.onInputTitleHandler} onKeyDown={this.onKeyDownTitleHandler}>{this.state.title}</span> */}
                            <span ref={el => (this.textEl = el)} className='text' contentEditable={this.state.editing} suppressContentEditableWarning={true} onInput={this.onInputTextHandler} onKeyDown={this.onKeyDownTextHandler}>{this.state.text}</span>
                            <div className="action-sign">
                                {editing ? null :
                                    <div className='action row lock'>
                                        <RectButton text="DELETE" onClick={()=>this.props.onDelete(this.props.index)} />
                                        <RectButton text="EDIT" onClick={() => this.setState({ editing: true })} />
                                    </div>
                                }
                                <div className="sign">
                                    {this.props.signed ? (this.state.tempSignature ? <img src={this.state.tempSignature} alt="Signature" /> : null) : "Ron Griffel"}
                                </div>
                            </div>
                            {editing ? <div className="characters">{this.state.tempText.length} / 500 Characters</div> : null}
                        </div>
                        {
                            editing ?
                                <div className='action row lock'>
                                    <RectButton text="SAVE" onClick={this.saveHandler} />
                                    <RectButton text="CANCEL" onClick={this.cancelHandler} />
                                </div> : null
                        }

                    </div>
                </div>
            </>
        )
    }
}

export default Template;